// Stałe dla systemu kontaktów i interakcji

// Typy podmiotów
export const ENTITY_TYPES = {
  client: 'Klient',
  lead: 'Lead'
};

// Typy kontaktów
export const CONTACT_TYPES = {
  phone_call: 'Rozmowa telefoniczna',
  whatsapp: 'WhatsApp',
  email: 'E-mail',
  in_person: 'Spotkanie',
  sms: 'SMS',
  note: 'Notatka',
  other: 'Inne'
};

// Wyniki spotkań
export const MEETING_OUTCOMES = {
  completed: 'Zakończone',
  rejected: 'Odrzucone',
  postponed: 'Przełożone',
  pending: 'Oczekujące'
};

// Funkcje pomocnicze
export const getEntityTypeLabel = (entityType) => {
  return ENTITY_TYPES[entityType] || entityType;
};

export const getContactTypeLabel = (contactType) => {
  return CONTACT_TYPES[contactType] || contactType;
};

export const getMeetingOutcomeLabel = (outcome) => {
  return MEETING_OUTCOMES[outcome] || outcome;
};

// Kolory statusów
export const getContactTypeColor = (type) => {
  switch (type) {
    case 'phone_call':
      return 'primary';
    case 'whatsapp':
      return 'success';
    case 'email':
      return 'info';
    case 'in_person':
      return 'secondary';
    case 'sms':
      return 'warning';
    case 'note':
      return 'default';
    default:
      return 'default';
  }
};

export const getMeetingOutcomeColor = (outcome) => {
  switch (outcome) {
    case 'completed':
      return 'success';
    case 'rejected':
      return 'error';
    case 'postponed':
      return 'warning';
    case 'pending':
      return 'info';
    default:
      return 'default';
  }
};

export const getEntityTypeColor = (type) => {
  switch (type) {
    case 'client':
      return 'primary';
    case 'lead':
      return 'secondary';
    default:
      return 'default';
  }
};
